import { Alert } from "@impero-com/ui";

import * as theme from "./ReassignmentFailureAlert.css";

export interface ReassignmentFailure {
    message: string;
    items: string[];
}

export function ReassignmentFailureAlert({
    failure,
}: {
    failure: ReassignmentFailure;
}) {
    return (
        <div className={theme.notice}>
            <div className={theme.noticeInner}>
                <Alert
                    type="error"
                    showIcon
                    message={
                        <span className={theme.title}>{failure.message}</span>
                    }
                    description={
                        <ul className={theme.list}>
                            {failure.items.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    }
                />
            </div>
        </div>
    );
}
